import React from "react";

const Footer = () => {
  return (
    <footer className="disclaimer">
      <p>
        Модель носит информационный характер. Не является офертой. Фактические
        результаты могут отличаться от расчетных.
      </p>
      <div className="footer-links">
        <a
          href="/src/docs/privacy-policy.pdf"
          target="_blank"
          rel="noopener noreferrer"
          className="doc-link"
        >
          Политика конфиденциальности
        </a>
        <a
          href="/src/docs/terms-of-use.pdf"
          target="_blank"
          rel="noopener noreferrer"
          className="doc-link"
        >
          Пользовательское соглашение
        </a>
      </div>
    </footer>
  );
};

export default Footer;
